import { useState } from "react";
import { NAVY, ORANGE, WHITE } from "./SharedLayout";

export function DetailedProductModal({ product, onClose }) {
    const [activeTab, setActiveTab] = useState("overview");
  
  const tabs = [
    { id: "overview", label: "Overview", icon: "📋" },
    { id: "composition", label: "Composition", icon: "🧪" },
    { id: "dosage", label: "Dosage", icon: "💊" },
    { id: "safety", label: "Safety Info", icon: "⚠️" },
    { id: "storage", label: "Storage", icon: "🏥" },
    { id: "regulatory", label: "Regulatory", icon: "📜" }
  ];

  // const catStyle = categoryColors[product.category] || {};

  return (
    <div 
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.6)", 
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000, padding: 20
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: WHITE,
          borderRadius: 20,
          maxWidth: 900,
          width: "100%",
          maxHeight: "90vh",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: "24px 32px",
          borderBottom: "1px solid #f1f5f9",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          background: `linear-gradient(135deg, #f8faff, ${WHITE})`
        }}>
          <div style={{ flex: 1 }}>
            {/* Category pill
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              background: catStyle.bg || "#f8faff",
              border: `1px solid ${catStyle.border || "#e5ecf9"}`,
              color: catStyle.text || NAVY,
              fontSize: 11,
              fontWeight: 700,
              padding: "4px 12px",
              borderRadius: 20,
              marginBottom: 12,
              textTransform: "uppercase",
              letterSpacing: 0.5,
            }}>
              <div style={{
                width: 6, height: 6, borderRadius: "50%",
                background: catStyle.text || NAVY,
              }} />
              {product.category}
            </div> */}

            <h2 style={{
              fontSize: 28,
              fontWeight: 700,
              color: NAVY,
              margin: "0 0 8px",
              letterSpacing: -0.5,
            }}>
              {product.title}
            </h2>
            
            <p style={{
              fontSize: 16,
              color: "#64748b",
              margin: "0 0 4px",
              fontStyle: "italic"
            }}>
              {product.generic_name}
            </p>
            
            <div style={{
              fontSize: 14,
              color: NAVY,
              fontWeight: 600
            }}>
              {product.strength} • {product.pack_size}
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
              color: "#94a3b8",
              padding: 8,
              borderRadius: 8,
            }}
          >
            ✕
          </button>
        </div>

        {/* Tabs */}
        <div style={{
          display: "flex",
          borderBottom: "1px solid #f1f5f9",
          background: "#f8fafc",
          overflowX: "auto"
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: "16px 24px",
                border: "none",
                background: activeTab === tab.id ? WHITE : "transparent",
                color: activeTab === tab.id ? NAVY : "#64748b",
                fontWeight: activeTab === tab.id ? 700 : 500,
                fontSize: 14,
                cursor: "pointer",
                borderBottom: activeTab === tab.id ? `3px solid ${ORANGE}` : "3px solid transparent",
                transition: "all 0.2s",
                display: "flex",
                alignItems: "center",
                gap: 8,
                whiteSpace: "nowrap"
              }}
            >
              <span>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div style={{
          padding: "32px",
          maxHeight: "60vh",
          overflowY: "auto"
        }}>
          {activeTab === "overview" && (
            <div>
              <h3 style={{ color: NAVY, fontSize: 20, fontWeight: 700, marginBottom: 16 }}>
                Product Overview
              </h3>
              
              {/* Drug Type */}
              <div style={{ marginBottom: 24 }}>
                <label style={{ color: "#64748b", fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>
                  Drug Type
                </label>
                <div style={{ color: NAVY, fontSize: 16, fontWeight: 600, marginTop: 4 }}>
                  {product.drug_type}
                </div>
              </div>

              {/* Indications */}
              <div style={{ marginBottom: 24 }}>
                <label style={{ color: "#64748b", fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8, display: "block" }}>
                  Primary Indications
                </label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {(product.indications || "")
  .split(/\r?\n/)
  .filter(Boolean)
  .map((indication, index) => (
    <span
      key={index}
      style={{
        background: "#f1f5f9",
        color: NAVY,
        padding: "6px 12px",
        borderRadius: 20,
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      {indication}
    </span>
))}
                </div>
              </div>

              {/* Detailed Description */}
              <div>
                <label style={{ color: "#64748b", fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8, display: "block" }}>
                  Detailed Description
                </label>
                <div style={{
                  color: "#475569",
                  fontSize: 15,
                  lineHeight: 1.6,
                  background: "#f8fafc",
                  padding: 20,
                  borderRadius: 12,
                  border: "1px solid #e2e8f0"
                }}>
                  {product.detailed_description || product.description || "Detailed product information will be displayed here when copied from the website."}
                </div>
              </div>
            </div>
          )}

          {activeTab === "composition" && (
            <div>
              <h3 style={{ color: NAVY, fontSize: 20, fontWeight: 700, marginBottom: 16 }}>
                Composition & Ingredients
              </h3>
              <div style={{
                color: "#475569",
                fontSize: 15,
                lineHeight: 1.6,
                background: "#f8fafc",
                padding: 20,
                borderRadius: 12,
                border: "1px solid #e2e8f0"
              }}>
                {product.composition || "Composition details will be displayed here when copied from the website."}
              </div>
            </div>
          )}

          {activeTab === "dosage" && (
            <div>
              <h3 style={{ color: NAVY, fontSize: 20, fontWeight: 700, marginBottom: 16 }}>
                Dosage & Administration
              </h3>
              <div style={{
                color: "#475569",
                fontSize: 15,
                lineHeight: 1.6,
                background: "#f8fafc",
                padding: 20,
                borderRadius: 12,
                border: "1px solid #e2e8f0"
              }}>
                {product.dosage_and_administration || "Dosage and administration guidelines will be displayed here when copied from the website."}
              </div>
            </div>
          )}

          {activeTab === "safety" && (
            <div>
              <h3 style={{ color: NAVY, fontSize: 20, fontWeight: 700, marginBottom: 24 }}>
                Safety Information
              </h3>
              
              {/* Contraindications */}
              <div style={{ marginBottom: 24 }}>
                <h4 style={{ color: "#dc2626", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  ⚠️ Contraindications
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 14,
                  lineHeight: 1.6,
                  background: "#fef2f2",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #fecaca"
                }}>
                  {product.contraindications || "Contraindications will be displayed here when copied from the website."}
                </div>
              </div>

              {/* Side Effects */}
              <div style={{ marginBottom: 24 }}>
                <h4 style={{ color: "#ea580c", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  🩹 Side Effects
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 14,
                  lineHeight: 1.6,
                  background: "#fff7ed",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #fed7aa"
                }}>
                  {product.side_effects || "Side effects information will be displayed here when copied from the website."}
                </div>
              </div>

              {/* Precautions */}
              <div>
                <h4 style={{ color: "#0369a1", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  🛡️ Precautions
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 14,
                  lineHeight: 1.6,
                  background: "#eff6ff",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #bfdbfe"
                }}>
                  {product.precautions || "Precautions and warnings will be displayed here when copied from the website."}
                </div>
              </div>
            </div>
          )}

          {activeTab === "storage" && (
            <div>
              <h3 style={{ color: NAVY, fontSize: 20, fontWeight: 700, marginBottom: 24 }}>
                Storage & Packaging
              </h3>
              
              {/* Storage Conditions */}
              <div style={{ marginBottom: 24 }}>
                <h4 style={{ color: "#0369a1", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  🌡️ Storage Conditions
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 15,
                  lineHeight: 1.6,
                  background: "#f0f9ff",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #bae6fd"
                }}>
                  {product.storage_conditions || "Storage conditions will be displayed here when copied from the website."}
                </div>
              </div>

              {/* Packaging Info */}
              <div>
                <h4 style={{ color: "#059669", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  📦 Packaging Information
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 15,
                  lineHeight: 1.6,
                  background: "#f0fdf4",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #bbf7d0"
                }}>
                  {product.packaging_info || product.pack_size || "Packaging information will be displayed here when copied from the website."}
                </div>
              </div>
            </div>
          )}

          {activeTab === "regulatory" && (
            <div>
              <h3 style={{ color: NAVY, fontSize: 20, fontWeight: 700, marginBottom: 24 }}>
                Regulatory & Manufacturing
              </h3>
              
              {/* Manufacturer Info */}
              <div style={{ marginBottom: 24 }}>
                <h4 style={{ color: "#7c3aed", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  🏭 Manufacturer Information
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 15,
                  lineHeight: 1.6,
                  background: "#faf5ff",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #e9d5ff"
                }}>
                  {product.manufacturer_info || "Manufacturer information will be displayed here when copied from the website."}
                </div>
              </div>

              {/* Regulatory Info */}
              <div>
                <h4 style={{ color: "#be123c", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
                  📋 Regulatory Status
                </h4>
                <div style={{
                  color: "#475569",
                  fontSize: 15,
                  lineHeight: 1.6,
                  background: "#fff1f2",
                  padding: 16,
                  borderRadius: 8,
                  border: "1px solid #fecdd3"
                }}>
                  {product.regulatory_info || "Regulatory information will be displayed here when copied from the website."}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}